import { render, staticRenderFns } from "./DeliveryStatus.vue?vue&type=template&id=20295458&"
import script from "./DeliveryStatus.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatus.vue?vue&type=style&index=0&id=20295458&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports